import { render, staticRenderFns } from "./TagNewPage.vue?vue&type=template&id=567518a5"
import script from "./TagNewPage.vue?vue&type=script&lang=ts"
export * from "./TagNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports